import { z } from 'zod';

const coreValueChangeKindCountsSchema = z.object({
    changedCoreValues3dCalculated: z.number().int(),
    changedCoreValuesSign: z.number().int(),
    changedCoreValuesScale: z.number().int(),
    changedCoreValuesRounding: z.number().int(),
    changedCoreValuesGeneral: z.number().int(),
    addedCoreValues3dCalculated: z.number().int(),
    removedCoreValues3dCalculated: z.number().int(),
});

const qualityStatisticsSchema = z.object({
    addedReports: z.number().int(),
    removedReports: z.number().int(),
    addedCoreValues: z.number().int(),
    changedCoreValues: z.number().int(),
    removedCoreValues: z.number().int(),
    addedLabels: z.number().int(),
    changedLabels: z.number().int(),
    removedLabels: z.number().int(),
    dataAddedBecauseOfNewDescriptor: z.number().int(),
    dataRemovedBecauseOfRemovedDescriptor: z.number().int(),
    coreValueChangeKindCounts: coreValueChangeKindCountsSchema,
    affectedRecords: z.number().int(),
});

const performanceScopeSchema = z.object({
    userId: z.number(),
    tableType: z.string(),
    cellsScope: z.number().nullable(),
    statistic: qualityStatisticsSchema,
});

const updatesPerformanceSchema = performanceScopeSchema.extend({
    purpose: z.string(),
    mistakePointsFromPeer: z.number().nullable(),
    mistakePointsFromQa: z.number().nullable(),
}).passthrough();

const reviewsPerformanceSchema = performanceScopeSchema.extend({
    type: z.string(),
    updatePurpose: z.string(),
    mistakePoints: z.number().nullable(),
}).passthrough();

const qaEffectivenessSchema = performanceScopeSchema.extend({
    detectedMistakes: z.number(),
}).passthrough();

export const performanceKpisSchema = z.object({
    updates: z.array(updatesPerformanceSchema),
    reviews: z.array(reviewsPerformanceSchema),
    qaEffectiveness: z.array(qaEffectivenessSchema),
}).passthrough();

export type PerformanceKpis = z.infer<typeof performanceKpisSchema>;
export type QualityStatistics = z.infer<typeof qualityStatisticsSchema>;
